const SHOW_MODAL_FORM = "SHOW_MODAL_FORM";
const HIDE_MODAL_FORM = "HIDE_MODAL_FORM";

const defaultState = {
    show: false,
    amount: 0
}

export default function modalFormReducer(state = defaultState, action) {
    switch (action.type) {
        case SHOW_MODAL_FORM:
            return {
                show: true,
                amount: action.payload.amount,
            }
        case HIDE_MODAL_FORM:
            return {
                show: false,
                amount: 0
            }
        default:
            return state;
    }
}